<div fxLayout="column">

  <app-page-header [section]="'Pay-Out History'" [title]="'View automatic platform pay-outs'" [description]="'The pay-out history views allows you to see all the pay-outs to your retailers. Based on the retailer you have selected you can view their payout status.'"></app-page-header>

  <div class="page-padding page-content full-screen-height-page-default" fxLayout="column">

    <div  fxLayout="row" fxLayoutAlign="space-between center" fxFlexOffset="20px">
        <span class="subtitle-default">Pay-out Summary</span>
      <app-custom-date-filter [customDateRangePresets]="dateFilters" (dateRange)="getDateRange($event)"
                              [initialPreset]="'1'"></app-custom-date-filter>
    </div>

    <div class="radius-10 mat-elevation-z3" fxLayout="column" fxFlexOffset="20px">
      <app-crud-table
        [title]="'Pay-out Summary '"
        [subTitle]="'Pay-out summary for retailers'"
        [modelType]="retailerBatchSummaryModelType"
        [loading$]="loading$"
        [tableData]="retailerBatchSummary"
      >
      </app-crud-table>
    </div>

    <mat-divider fxFlexOffset="15px"></mat-divider>

    <div class="info-card-dark radius-10" fxLayout="column" fxLayoutGap="20px" fxFlexOffset="20px">
      <div class="mat-icon-encircle">
        <mat-icon class="mat-icon material-icons-outlined">shopping_bag</mat-icon>
      </div>
      <div [formGroup]="amountForm" class="full-width" fxLayout="row" fxLayoutAlign="space-between center">
        <span class="heading-bold">Minimum pay-out</span>
        <mat-form-field appearance="outline" class="custom-text-field" floatLabel="always">
          <mat-label>Amount</mat-label>
          <input [disabled]="true" class="text-number-input" formControlName="amount" matInput min="0" type="number"/>
        </mat-form-field>
      </div>
      <div fxLayout="column" fxLayoutGap="15px">
        <span class="body-1-regular-2">This setting is applied for all payment groups</span>


        <div fxLayout="column">
        <span class="heading-bold">Pay-out Statuses</span>
          <ul>
            <li><span class="body-1-regular-2">Open: not finalised on the POS system</span></li>
            <li><span class="body-1-regular-2">Pending Payment: billing applied, can be paid out if minimum payout amount reached</span></li>
            <li><span class="body-1-regular-2">Error: various processing errors, pre or post billing</span></li>
          </ul>

        </div>
        <br/>

        <span class="heading-bold">Notes</span>
        <span class="body-1-regular-2">External payments are not collected and therefore not paid out</span>

      </div>
    </div>
  </div>

</div>
